export default "<ion-app>\n  <app-top-bar></app-top-bar>\n  <ion-router-outlet></ion-router-outlet>\n  <app-footer></app-footer>\n</ion-app>";